import React, { ReactNode } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import ArrowDropUpSharpIcon from "@mui/icons-material/ArrowDropUpSharp";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";

type AnalyticsCardLayoutProps = AnalyticsHeaderProps & {
  children: ReactNode;
  bgcolor?: string;
};
function AnalyticsCardLayout({
  children,
  handleDownload,
  title,
  details,
  percentageChange,
  bgcolor,
  ...rest
}: AnalyticsCardLayoutProps) {
  return (
    <Box bgcolor={bgcolor || "white"} p={2} sx={{ borderRadius: "8px" }}>
      <AnalyticsHeader
        handleDownload={handleDownload}
        title={title}
        details={details}
        percentageChange={percentageChange}
      />
      <Box my={1}>
        <Divider />
      </Box>
      <Box>{children}</Box>
    </Box>
  );
}

type AnalyticsHeaderProps = {
  handleDownload?: () => any;
  title: string;
  details?: string;
  percentageChange?: number;
};
export function AnalyticsHeader({
  handleDownload,
  title,
  details,
  percentageChange,
}: AnalyticsHeaderProps) {
  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Box>
          <Typography variant="body2" mb={3} fontWeight={500} fontSize={16}>
            {title}
          </Typography>
          <Typography variant="body2" fontWeight={700} fontSize={22}>
            {details}
          </Typography>
        </Box>
        <Box>
          {!!percentageChange && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "right",
              }}
              mb={0.5}
            >
              <Typography
                variant="body2"
                align="right"
                // mb={0.5}
                fontSize={16}
                fontWeight={700}
                color="#1E1B39"
              >
                {percentageChange}
              </Typography>
              <ArrowDropUpSharpIcon sx={{ fontSize: "32px", color: "green" }} />
            </Box>
          )}
          {!!percentageChange && (
            <Typography
              variant="body2"
              align="right"
              mb={0.5}
              fontSize={14}
              color="#615E83"
            >
              Vs Last Week
            </Typography>
          )}
          <Box mt={2} mb={1}>
            <Button
              endIcon={<DownloadIcon />}
              variant="outlined"
              onClick={handleDownload}
            >
              Download
            </Button>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
}
export default AnalyticsCardLayout;
